function strengthScore(pwd) {
  if (!pwd) return 0;
  let s = 0;
  if (pwd.length >= 8) s++;
  if (pwd.length >= 14) s++;
  if (/[A-Z]/.test(pwd)) s++;
  if (/[0-9]/.test(pwd)) s++;
  if (/[^A-Za-z0-9]/.test(pwd)) s++;
  return s;
}
const strengthColor = ["", "#e74c3c", "#e67e22", "#f1c40f", "#2ecc71", "#27ae60"];
const strengthLabel = ["", "Muy débil", "Débil", "Regular", "Fuerte", "Muy fuerte"];

function generatePassword(length = 16) {
  const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lower = "abcdefghijklmnopqrstuvwxyz";
  const nums  = "0123456789";
  const syms  = "!@#$%^&*()_+-=[]{}";
  const all   = upper + lower + nums + syms;
  let pwd = [
    upper[Math.floor(Math.random() * upper.length)],
    lower[Math.floor(Math.random() * lower.length)],
    nums[Math.floor(Math.random() * nums.length)],
    syms[Math.floor(Math.random() * syms.length)],
  ];
  for (let i = 4; i < length; i++) pwd.push(all[Math.floor(Math.random() * all.length)]);
  return pwd.sort(() => Math.random() - 0.5).join("");
}

const S = {
  genWrap: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 },
  genCard: { background: "var(--card)", border: "0.5px solid var(--border)", borderRadius: 10, padding: 24 },
  genPwdDisplay: { background: "var(--lift)", border: "0.5px solid var(--border)", borderRadius: 8, padding: "14px 16px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 },
  genPwdText: { fontFamily: "monospace", fontSize: 14, color: "var(--gold)", letterSpacing: 2, wordBreak: "break-all", flex: 1 },
  copyBtn: { display: "flex", alignItems: "center", gap: 6, padding: "8px 16px", background: "none", color: "var(--gold)", border: "1px solid var(--goldDim)", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 700, fontFamily: "Syne, sans-serif", letterSpacing: "0.1em", textTransform: "uppercase", flexShrink: 0 },
  genBtn: { display: "flex", alignItems: "center", justifyContent: "center", gap: 6, padding: "10px 18px", background: "var(--gold)", color: "var(--bgApp)", border: "none", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 700, fontFamily: "Syne, sans-serif", letterSpacing: "0.1em", textTransform: "uppercase", width: "100%" },
  label: { fontSize: 10, color: "var(--mute)", fontFamily: "Syne, sans-serif", letterSpacing: "0.08em", textTransform: "uppercase" },
  sectionTitle: { color: "var(--gold)", marginBottom: 16, fontSize: 11, fontFamily: "Syne, sans-serif", letterSpacing: "0.12em", textTransform: "uppercase", fontWeight: 700 },
  tip: { display: "flex", gap: 10, marginBottom: 12, fontSize: 13, color: "var(--textSub)", fontFamily: "Syne, sans-serif", lineHeight: 1.5 },
};

export default function Generator({ genLen, setGenLen, genPwd, setGenPwd, onCopy }) {
  const score = strengthScore(genPwd);
  const isMobile = window.innerWidth <= 768;
  return (
    <div style={{ ...S.genWrap, gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr" }}>
      <div style={S.genCard}>
        <div style={S.genPwdDisplay}>
          <span style={S.genPwdText}>{genPwd}</span>
          <button style={S.copyBtn} onClick={() => onCopy(genPwd, "gen")}>Copiar</button>
        </div>

        <div style={{ display: "flex", gap: 4, margin: "16px 0 6px" }}>
          {[1,2,3,4,5].map(i => (
            <div key={i} style={{ flex: 1, height: 4, borderRadius: 2,
              background: i <= score ? strengthColor[score] : "var(--border)",
              transition: "background 0.3s" }} />
          ))}
        </div>
        <div style={{ fontSize: 11, color: strengthColor[score], marginBottom: 20,
          fontFamily: "Syne, sans-serif", letterSpacing: "0.06em" }}>
          {strengthLabel[score]}
        </div>

        <div style={S.label}>Longitud: {genLen} caracteres</div>
        <input type="range" min={8} max={32} value={genLen}
          onChange={e => { setGenLen(+e.target.value); setGenPwd(generatePassword(+e.target.value)); }}
          style={{ width: "100%", margin: "10px 0 20px", accentColor: "var(--gold)" }} />

        <button onClick={() => setGenPwd(generatePassword(genLen))} style={S.genBtn}>
          ↻ Generar nueva contraseña
        </button>
      </div>

      <div style={S.genCard}>
        <div style={S.sectionTitle}>Consejos de seguridad</div>
        {[
          "Usa una contraseña diferente para cada sistema",
          "Mínimo 14 caracteres para cuentas críticas",
          "Combina mayúsculas, números y símbolos",
          "Nunca compartas contraseñas por email o WhatsApp",
          "Cambia las contraseñas de aseguradoras cada 6 meses",
        ].map(tip => (
          <div key={tip} style={S.tip}>
            <span style={{ color: "#2ecc71", flexShrink: 0 }}>✓</span>{tip}
          </div>
        ))}
      </div>
    </div>
  );
}

export { generatePassword };
